import React, { FC, memo, useState } from 'react'
import Carousel, { CarouselProps } from 'react-multi-carousel';
import ReactPlayer from 'react-player';
import { FaCirclePlay } from "react-icons/fa6";
import { ReactBootstrapPopUp } from 'modal/react-bootstrap-pop-up';

interface VideosProps {
  videos: Array<string>;
  onOpenVideo: (videoUrl: string) => void;
}

const responsive = {};
let min = 0;
let max = 370;

for(let i = 0; i < 30; i++) {
  responsive[i] = {
    breakpoint: { min, max },
    items: i + 1,
  }
  min = max;
  max += 370;
}

const carouselProps: CarouselProps = {
  additionalTransfrom: 0,
  arrows: true,
  draggable: true,
  keyBoardControl: true,
  minimumTouchDrag: 80,
  pauseOnHover: true,
  shouldResetAutoplay: true,
  sliderClass: "",
  slidesToSlide: 1,
  swipeable: true,
  responsive,
  children: null,
  className: "mt-5"
}

export const Videos: FC<VideosProps> = memo(({ videos, onOpenVideo }) => {
  const [selectedVideo, setSelectedVideo] = useState<string | null>(null);
  
  if (videos.length === 0) {
    return null;
  }
  
  return (
    <>
      <Carousel
        {...carouselProps}
      >
        {videos.map((video) => (
          <div
            onClick={() => {
              setSelectedVideo(video);
              onOpenVideo(video);
            }}
            key={video}
            className="d-flex flex-column position-relative h-100 overflow-hidden mx-2 rounded-lg position-relative cursor-pointer"
          >
            <ReactPlayer className="w-100 h-100" src={video} />
            <FaCirclePlay className="position-absolute w-50 h-50 text-white" style={{
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)'
            }} />
          </div>
        ))}
      </Carousel>
      {selectedVideo && (
        <ReactBootstrapPopUp
          modalProps={{
            centered: true,
            contentClassName: 'h-100 overflow-auto',
          }}
          isShow={!!selectedVideo}
          handleClose={() => setSelectedVideo(null)}
          bodyContent={<ReactPlayer className='w-100 h-100' src={selectedVideo} controls />}
        />
      )}
    </>
  )
})